module.exports = __webpack_public_path__ + "static/media/signout.abaef657.svg";